import axios from 'axios';

import * as actionTypes from './actionTypes';
import Alert from 'react-s-alert';
import {backendEndpoint} from '../utility';

export const settingGet = () => {
    return (dispatch, getState) => {

        const state = getState();
        const authToken = state.auth.token;
        const calendarId = state.auth.calendarId;
        let url = backendEndpoint + 'calendar/' + calendarId + '/get_setting/';
        // load state information
        axios.get(url, {
            headers: {'Authorization': 'Token '+ authToken}
        })
            .then(function (response) {
                let schedule_setting = response.data.schedule_setting;
                dispatch(settingGetSucceeded(schedule_setting));
            })
            .catch(function (error) {
                console.log(error);
            });
    }
};

export const settingGetSucceeded = (schedule_setting) =>{
    return {
        type: actionTypes.SETTING_GET,
        weekSchedule: schedule_setting,
    };
}


export const scheduleSettingSet = (calendar_id, scheduleSetting) => {

    return (dispatch, getState) => {
        // load state information
        const state = getState();
        const authToken = state.auth.token;
        const calendarId = state.auth.calendarId;
        let url = backendEndpoint + 'calendar/' + calendarId + '/set_schedule_setting/';
        let setScheduleSettingData = {
            timezone: scheduleSetting.timezone,
            days: {
                monday: scheduleSetting.monday,
                tuesday: scheduleSetting.tuesday,
                wenesday: scheduleSetting.wenesday,
                thursday: scheduleSetting.thursday,
                friday: scheduleSetting.friday,
                saturday: scheduleSetting.saturday,
                sunday: scheduleSetting.sunday,
            }
        }

        axios.post(url, setScheduleSettingData, {
            headers: {'Authorization': 'Token '+ authToken}
        })
            .then(response => {
                console.log(response);
                dispatch(settingGet()); // getting the setting again
            })
            .catch(err => {
                Alert.error('set schedule failed');
            });
    }
};


// WEBPACK FOOTER //
// ./src/store/actions/setting.js